export const WizardLanguage = {
  Russian: 'russian',
  English: 'english'
}
